module.exports = __webpack_public_path__ + "static/media/Modesto.d28abe13.jpg";